import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NavController } from '@ionic/angular';

import { ApiService } from 'src/services/api.service';
import { MessageService } from 'src/services/message.service';

import { routes } from '../constants';

@Component({
  selector: 'app-unsubscribe',
  templateUrl: './unsubscribe.component.html',
  styleUrls: ['./unsubscribe.component.css'],
})
export class UnsubscribeComponent implements OnInit {
  token: string;
  tenantId: string;
  email: string;
  outboundId: string;
  isUnsubscribed: boolean;
  isLoading = false;
  isInitialized = false;

  constructor(
    private route: ActivatedRoute,
    private msgSrvc: MessageService,
    private navController: NavController,
    private apiService: ApiService,
  ) {}

  ngOnInit() {
    this.token = this.route.snapshot.queryParamMap.get('token');
    this.tenantId = this.route.snapshot.queryParamMap.get('tenantId');
    this.email = this.route.snapshot.queryParamMap.get('email');
    this.outboundId = this.route.snapshot.queryParamMap.get('outboundId');

    if (!this.token || !this.tenantId) {
      this.msgSrvc.show('Missing required fields to manage your subscription');
      this.navController.navigateRoot(routes.DASHBOARD);
      return;
    }

    this.getSubscription();
  }

  async getSubscription() {
    try {
      this.isInitialized = false;
      const result: { isUnsubscribed: boolean; email: string } = await this.apiService.getPromise(
        '/email/subscription',
        {
          token: this.token,
          email: this.email,
          tenantId: this.tenantId,
        },
      );
      this.isUnsubscribed = result.isUnsubscribed;
      this.email = result.email;
      this.isInitialized = true;
    } catch (error) {
      this.msgSrvc.showError(error);
    } finally {
      this.isLoading = false;
    }
  }

  async updateSubscription(subscribe: boolean) {
    this.isLoading = true;
    try {
      const result: { isUnsubscribed: boolean } = await this.apiService.postPromise('/email/subscription', {
        token: this.token,
        email: this.email,
        tenantId: this.tenantId,
        isUnsubscribed: !subscribe,
      });
      this.isUnsubscribed = result.isUnsubscribed;

      if (this.isUnsubscribed) {
        this.msgSrvc.show(`✔ You've been unsubscribed`);
      }
    } catch (error) {
      this.msgSrvc.showError(error);
    } finally {
      this.isLoading = false;
    }
  }

  unsubscribe() {
    this.updateSubscription(false);
  }

  resubscribe() {
    this.updateSubscription(true);
  }
}
